import React, { useState } from "react";
import styles from "./SocialSideBar.module.css"; // Import CSS module
import { FaWhatsapp, FaTelegramPlane, FaEnvelope } from "react-icons/fa";

const SocialSideBar = () => {
  const [active, setActive] = useState(null);

  const links = [
    {
      id: "whatsapp",
      icon: <FaWhatsapp className={styles.icon} />, // Use styles object
      text: "WhatsApp Us",
      url: "https://wa.me/910000000000", // change your number
      color: "whatsapp",
    },
    /*{
      id: "telegram",
      icon: <FaTelegramPlane className={styles.icon} />,
      text: "Telegram",
      url: "https://t.me/+817083110880", // change your username
      color: "telegram",
    },*/
    {
      id: "email",
      icon: <FaEnvelope className={styles.icon} />, // Use styles object
      text: "Email Us",
      url: "mailto:support@prrepxpathshala.live", // change your email
      color: "email",
    },
  ];

  return (
    <div className={styles.socialSidebar}> {/* Use styles object */}
      {links.map((link) => (
        <a
          key={link.id}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          // Use template literal for dynamic classes
          className={`
            ${styles.socialLink} 
            ${styles[link.color]} 
            ${active === link.id ? styles.active : ""}
          `}
          onMouseEnter={() => setActive(link.id)}
          onMouseLeave={() => setActive(null)}
          onTouchStart={() =>
            setActive(active === link.id ? null : link.id)
          }
        >
          {link.icon}
          <span className={styles.text}>{link.text}</span> {/* Use styles object */}
        </a>
      ))}
    </div>
  );
};

export default SocialSideBar;